var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1751_41007",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1751_41007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.25H6.25C6.0375 13.25 5.85938 13.1781 5.71563 13.0343C5.57188 12.8904 5.5 12.7122 5.5 12.4997C5.5 12.2871 5.57188 12.109 5.71563 11.9654C5.85938 11.8218 6.0375 11.75 6.25 11.75H11.25V6.75C11.25 6.5375 11.3219 6.35938 11.4657 6.21563C11.6095 6.07188 11.7877 6 12.0003 6C12.2129 6 12.391 6.07188 12.5346 6.21563C12.6782 6.35938 12.7499 6.5375 12.7499 6.75V11.75H17.75C17.9625 11.75 18.1406 11.8219 18.2843 11.9657C18.4281 12.1095 18.5 12.2877 18.5 12.5003C18.5 12.7129 18.4281 12.891 18.2843 13.0346C18.1406 13.1782 17.9625 13.25 17.75 13.25H12.7499V18.25C12.7499 18.4625 12.678 18.6406 12.5342 18.7843C12.3904 18.9281 12.2122 19 11.9997 19C11.7871 19 11.609 18.9281 11.4654 18.7843C11.3218 18.6406 11.25 18.4625 11.25 18.25V13.25Z",
    fill: "#0360D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.13e30105e5860715ad75de7ec4fcde27.svg";
export { ForwardRef as ReactComponent };